import { all, call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { CONSTANTS } from 'utils';
import { logSagaErrorMessage } from 'utils/logSagaErrorMessage';
import { request } from 'helpers/request';
import { getIntegrations, getOrganizationTypes } from './main.actions';
import { IIntegrationList, IOrganizationTypeList } from '../models';
import * as types from './ActionTypes';

function* getIntegrationsSaga() {
	try {
		yield put(getIntegrations.loading());

		const getIntegrationsParams = {
			url: `${CONSTANTS.baseApiPath}${CONSTANTS.moduleAdminPath}/integration/all`,
		};

		const { data }: AxiosResponse<IIntegrationList> = yield call(
			request,
			getIntegrationsParams,
		);

		yield put(getIntegrations.success(data));
	} catch (e) {
		logSagaErrorMessage('getIntegrations', e);
		yield put(getIntegrations.fail(e));
	}
}

function* getOrganizationTypesSaga() {
	try {
		yield put(getOrganizationTypes.loading());

		const getOrganizationTypesParams = {
			url: `${CONSTANTS.baseApiPath}${CONSTANTS.moduleAdminPath}/org_type/all`,
		};

		const { data }: AxiosResponse<IOrganizationTypeList> = yield call(
			request,
			getOrganizationTypesParams,
		);

		yield put(getOrganizationTypes.success(data));
	} catch (e) {
		logSagaErrorMessage('> Failed getOrganizationTypes: ', e);
		yield put(getOrganizationTypes.fail(e));
	}
}

export function* mainSaga() {
	yield all([
		takeEvery(types.GET_INTEGRATIONS.DEFAULT, getIntegrationsSaga),
		takeEvery(types.GET_ORGANISATION_TYPES.DEFAULT, getOrganizationTypesSaga),
	]);
}
